// extracted by mini-css-extract-plugin
module.exports = {"containerModal":"ModalDownload_containerModal__R1ZBm","containerButtons":"ModalDownload_containerButtons__2a-sB"};